// ACTION TYPES
const TEACHER_SUBJECTS_LOAD_REQUEST = 'TEACHER_SUBJECTS_LOAD_REQUEST';
const TEACHER_SUBJECTS_LOAD_SUCCESS = 'TEACHER_SUBJECTS_LOAD_SUCCESS';
const TEACHER_SUBJECTS_LOAD_FAILURE = 'TEACHER_SUBJECTS_LOAD_FAILURE';

// ACTION REDUCERS
const initialState = {
  teacherSubjects: {
    isLoading: true,
    items: [],
  },
};

function teacherSubjects(state = initialState.teacherSubjects, action) {
  switch (action.type) {
    case TEACHER_SUBJECTS_LOAD_SUCCESS:
      return {...state, isLoading: false, items: [...action.teacherSubjects.subjects]};

    case TEACHER_SUBJECTS_LOAD_FAILURE:
      return {...state, isLoading: false, error: action.error};

    default:
      return state;
  }
}

// ACTION CREATORS
function requestTeacherSubjects(teacherId) {
  return {type: TEACHER_SUBJECTS_LOAD_REQUEST, teacherId};
}

function loadTeacherSubjectsSuccess(data) {
  return {
    type: TEACHER_SUBJECTS_LOAD_SUCCESS,
    teacherSubjects: data,
    receivedAt: Date.now()
  };
}

function loadTeacherSubjectsFailure() {
  return {
    type: TEACHER_SUBJECTS_LOAD_FAILURE,
    teacherSubjects: [],
    receivedAt: Date.now()
  };
}

export {
  loadTeacherSubjectsFailure,
  loadTeacherSubjectsSuccess,
  requestTeacherSubjects,
  teacherSubjects,
  TEACHER_SUBJECTS_LOAD_FAILURE,
  TEACHER_SUBJECTS_LOAD_REQUEST,
  TEACHER_SUBJECTS_LOAD_SUCCESS,
};
